let base_url = process.env.VUE_APP_BASE_URL;
export default base_url